import React, { useContext, useState, useEffect } from 'react'
import { Box, Grid, Theme, styled, useMediaQuery } from '@mui/material'
import { NavigationContext } from '../../Store/Navigation/context'
import StatisticsSidebar from './StatisticsSidebar'
import { ActionType } from '../../Store/Navigation/actions'
import ContainerContainer from '../../components/container/ContainerContainer'
import IFrame from './components/IFrame'
import { getFullApiUrl} from '../../config/axios'
import { useSnackbar } from 'notistack'

const GridTab = styled(Grid)(({ theme }) => ({
    paddingLeft: '2rem',
    [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
    },
}))

const GridBar = styled(Grid)(() => ({
    paddingTop: '2.1rem',
    position: 'sticky',
    top: 'max(7vh, 50px)',
    height: 'fit-content',
}))

export enum StatisticsType {
    MMID = 'MMID',
    SYSTEM = 'SYSTEM',
}

const Statistics: React.FC = () => {

    const { enqueueSnackbar } = useSnackbar();
    const breakpoint = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))
    const { state, dispatch } = useContext(NavigationContext)
    const [statistics, setStatistics] = useState<StatisticsType>(state.statisticsType)

    useEffect(() => {
        setStatistics(state.statisticsType)
    }, [state.statisticsType])

    const setStatisticsType = (type: StatisticsType) => {
        setStatistics(type)
        dispatch({ type: ActionType.SetStatisticsType, statisticsType: type })
    }

    const makeSrc = (type: StatisticsType) => {
        let baseValueUrl
        switch (type) {
            case StatisticsType.MMID:
                baseValueUrl = `${getFullApiUrl()}/grafana/d/mmid-dashboard-uuid/mmid-metrics`
                break;
            case StatisticsType.SYSTEM:
                baseValueUrl = `${getFullApiUrl()}/grafana/d/rYdddlPWk/node-exporter-full`
                break;
            default:
                enqueueSnackbar("Could not determine Statistics type", {variant: "error"})
                return;
        }
        const params = new URLSearchParams({
            theme: 'light',
        })
        return `${baseValueUrl}?${params.toString()}&kiosk`
    }

    return (
        <ContainerContainer maxWidth={false} >
            <Grid container style={{ position: 'relative' }}>
                <GridBar item md={1.5} xs={0}>
                    {breakpoint && (
                        <StatisticsSidebar
                            activeStatistics={statistics}
                            setStatistics={setStatisticsType}
                        />
                    )}
                </GridBar>
                <GridTab item md={10.5} xs={12}>
                    <Box flex={1} overflow="auto" p={2} style={{height: "85vh"}}>
                        <IFrame
                            style={{ width: '100%', height: "100%", margin: "-1rem", paddingTop: "1rem" }}
                            disableOverlay
                            src={makeSrc(statistics)}
                        />
                    </Box>
                </GridTab>
            </Grid>
        </ContainerContainer>
    )
}

export default Statistics